export const APIs = {
  apiBancoBitrix: {
    name: 'API Banco Bitrix',
    description: 'API Principal - Via Proxy Backend',
    icon: 'Database',
    color: 'bg-blue-500',
    gradient: 'from-blue-500 to-blue-600',
    baseUrl: 'proxy', // Usar proxy do backend
    endpoints: [
      { path: '/json', name: 'JSON', description: 'Dados principais' },
      { path: '/formulario', name: 'Formulário', description: 'Dados de formulários' },
      { path: '/franquiamobile', name: 'Franquia Mobile', description: 'Dados de franquias' }
    ]
  },
  apiRegistroInteresse: {
    name: 'API Registro Interesse',
    description: 'Gerenciamento de Registros - Via Proxy',
    icon: 'FileText',
    color: 'bg-green-500',
    gradient: 'from-green-500 to-green-600',
    baseUrl: 'proxy', // Usar proxy do backend
    endpoints: [
      { path: '/', name: 'Principal', description: 'Dados principais' }
    ]
  },
  apiBitrixComentarios: {
    name: 'API Comentários',
    description: 'Sistema de Comentários - Via Proxy',
    icon: 'MessageCircle',
    color: 'bg-purple-500',
    gradient: 'from-purple-500 to-purple-600',
    baseUrl: 'proxy', // Usar proxy do backend
    endpoints: [
      { path: '/registroInteresse', name: 'Registro Interesse', description: 'Lista de arquivos' },
      { path: '/status', name: 'Status', description: 'Status da API' },
      { path: '/produtos/secoes', name: 'Seções', description: 'Seções do catálogo' },
      { path: '/produtos/catalogo', name: 'Catálogo', description: 'Produtos do catálogo' }
    ]
  },
  apiBitrixComentarioNovo: {
    name: 'API Comentários Novo',
    description: 'Sistema Atualizado - Via Proxy',
    icon: 'MessageCircle',
    color: 'bg-red-500',
    gradient: 'from-red-500 to-red-600',
    baseUrl: 'proxy', // Usar proxy do backend
    endpoints: [
      { path: '/', name: 'Principal', description: 'Dados principais' }
    ]
  },
  apiRegistroConversa: {
    name: 'API Registro Conversa',
    description: 'Sistema de Conversas - Via Proxy',
    icon: 'MessageSquare',
    color: 'bg-orange-500',
    gradient: 'from-orange-500 to-orange-600',
    baseUrl: 'proxy', // Usar proxy do backend
    endpoints: [
      { path: '/', name: 'Principal', description: 'Dados principais' }
    ]
  }
};
